const StockNotice = ({ notice, className = '' }) => {
  if (!notice) return null;
  const isError = notice.type === 'error';
  return (
    <p
      className={`text-sm mt-2 ${isError ? 'text-red-400' : 'text-amber-400'} ${className}`}
      role="alert"
    >
      {notice.message}
    </p>
  );
};

export default StockNotice;
